import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import Resizer from "react-image-file-resizer";
import { fetchAppParameter } from "../../actions/commonAction";
import { MdClose } from "react-icons/md";
import{ singleImageURL} from "../configC/keys"
import {
  Image,
  //Segment,
  Header,
  Button,
  Icon,
  // Input,
  // Form,
} from "semantic-ui-react";

// import { imageOfProperty,imageOfProject, belongTo, } from "./DataImg";
const initialState = {
  files: [],
  image: {},
  imageUrl: "",
  //*********** */
  height: 768,
  width: 1280,
  orientation: "Landscape",
  // showForm: false,
  hasDimention: "",
};
class AddImage extends React.Component {
  state = initialState;

  componentDidMount() {
    if (!this.props.parameter) {
      this.props.fetchAppParameter();
    }
  }

  fileChangedHandler = (event) => {
    this.setState({ files: event.target.files });
  };
  fileResizeHandler = () => {
    const file = this.state.files[0];
    if (file) {
      Resizer.imageFileResizer(
        file,
        this.props.width || this.state.width,
        this.props.height || this.state.height,
        "WEBP",
        90,
        0,
        (uri) => {
          this.setState({
            imageUrl: URL.createObjectURL(uri),
            image: uri,
          });
        },
        "blob"
      );
    }
  };
  // ****************

  cancelImage = () => {
    this.setState(initialState);
  };

  // handleChange = (event) => {
  //   const target = event.target;
  //   const value = target.type === "checkbox" ? target.checked : target.value;
  //   const name = target.name;

  //   this.setState({
  //     [name]: value,
  //     orientation: "Custom",
  //   });
  // };

  // ***************
  handleUploadImage = async (ev) => {
    ev.preventDefault();
    // const imageURL =
    //   this.props.parameter !== undefined &&
    //   this.props.parameter !== null &&
    //   this.props.parameter.currentURL;
    const imageURL = singleImageURL;

    const data = new FormData();
    data.append("file", this.state.image);
    data.append("id", this.props.id);
    data.append("folder", this.props.folder);
    data.append("path", this.props.path);

    const imgRoute = this.props.imgRoute;
    const apiRoute = this.props.apiRoute;
    // console.log("imageURL", imageURL);
    try {
      const resImage = await axios.post(`${imageURL}/AddImage`, data);
      if (resImage.data.msg === "success") {
        const values = {
          id: this.props.id,
          path: resImage.data.path,
        };

        const res = await axios.put(`${apiRoute}`, values);
        if (res.data.msg === "success") {
          toastr.success("Image Added Successfully");
          this.setState(initialState);
          this.props.handleImgModalCloseSubmit();
        }
      }
    } catch (error) {
      console.log("error_addImage", error);
      toastr.error("Oops", "Something went wrong.Please Try Again_addimage");
    }
  };

  //*************** */

  setHeightWidthToPortrait = () => {
    this.setState({
      height: 1280,
      width: 768,
      orientation: "Portrait",
      image: {},
      imageUrl: "",
    });
  };
  setHeightWidthToLandscape = () => {
    this.setState({
      height: 768,
      width: 1280,
      orientation: "Landscape",
      image: {},
      imageUrl: "",
    });
  };

  //@@@@@@@@

  // showHideForm = () => {
  //   this.setState({
  //     showForm: !this.state.showForm,
  //   });
  // };
  // renderForm = () => {
  //   return (
  //     <div  style={{
  //       maxWidth:'500px',
  //       padding: "15px",
  //       color: "dodgerblue",
  //     }}>
  //      <div
  //           style={{
  //             textAlign: "center",
  //             fontSize: "1.3rem",
  //             fontWeight: "bold",
  //             padding: "15px",
  //             color: "dodgerblue",
  //           }}
  //         >
  //           Set Custom Height and  Width of Image
  //           {/*  */}
  //         </div>
  //      <Form >
  //             <Form.Field>
  //               <label>Height</label>
  //               <Input
  //                 type="text"
  //                 placeholder="Height"
  //                 name="height"
  //                 value={this.state.height}
  //                 onChange={this.handleChange}
  //               />
  //             </Form.Field>
  //             <Form.Field>
  //               <label>Width</label>
  //               <Input
  //                 type="text"
  //                 placeholder="Width"
  //                 name="width"
  //                 value={this.state.width}
  //                 onChange={this.handleChange}
  //               />
  //             </Form.Field>

  //             <Button.Group>
  //               <Button
  //                 //inverted
  //                 color="blue"
  //                 type="button"
  //                 onClick={this.fileResizeHandler}
  //               >
  //                 Submit
  //               </Button>
  //               <Button
  //                 //inverted
  //                 style={{ marginLeft: "10px" }}
  //                 color="teal"
  //                 onClick={this.showHideForm}
  //               >
  //                 Cancel
  //               </Button>
  //             </Button.Group>

  //         </Form>

  //     </div>

  //   );
  // };
  //@@@@@@@@@@@@@

  render() {
    const renderAddImageButton = () => {
      if (this.state.files.length < 1) {
        return (
          <React.Fragment>
            <div>
              <label
                size="tiny"
                htmlFor="hidden-new-file"
                className="ui icon button"
              >
                <span className="icon-size">
                  <Icon name="plus circle" />
                </span>
                <span className="icon-size">Choose your image</span>
              </label>
              <input
                type="file"
                id="hidden-new-file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={this.fileChangedHandler}
              />
            </div>
          </React.Fragment>
        );
      }
    };

    //*******************
    const renderPreview = () => {
      if (this.state.files.length > 0) {
        return (
          <React.Fragment>
            <div
            //style={{padding:'15px'}}
            >
              <br />
              <Header color="teal" content="Preview and Upload" />
              {this.props.hasDimention && (
                <h6>
                  <span>Orientation : {this.state.orientation} #</span>{" "}
                  <span>Height : {this.state.height} #</span>{" "}
                  <span>Width : {this.state.width} </span>
                </h6>
              )}
              <br />
              <Image src={this.state.imageUrl} />
            </div>

            <br />
            <br />
            <div className="disflex-paginator">
              <Button.Group>
                {!this.state.imageUrl && (
                  <Button
                    size="mini"
                    onClick={this.fileResizeHandler}
                    color="teal"
                    content="Preview"
                  />
                )}
                {this.state.imageUrl && (
                  <Button
                    onClick={this.handleUploadImage}
                    // style={{ width: '120px' }}
                    positive
                    icon="check"
                    content="upload"
                  />
                )}
                <Button
                  size="mini"
                  onClick={this.cancelImage}
                  // style={{ width: '100px' }}
                  icon="close"
                  content="cancell"
                />
              </Button.Group>
            </div>
          </React.Fragment>
        );
      }
    };
    //******************** */
    return (
      <>
        <div
          className="main-div  min-max-width"
          style={{ backgroundColor: "white" }}
        >
          {this.props.hasCloseBtn && (
            <span
              style={{ color: "black", paddingTop: "7px" }}
              className="close-btn"
              onClick={this.props.handleCloseModal}
            >
              <MdClose />
            </span>
          )}
          <div style={{ textAlign: "center", padding: "0px" }}>
            {/**/}
            <div
              style={{
                textAlign: "center",
                fontSize: "1.5rem",
                fontWeight: "bold",
                padding: "15px",
                color: "dodgerblue",
              }}
            >
              Add Image
              {/*  */}
            </div>

            {/**/}
            {this.state.files.length < 1 && renderAddImageButton()}

            {this.props.hasDimention && this.state.files.length > 0 && (
              <div>
                <Button
                  disabled={
                    this.state.orientation === "Portrait" ? true : false
                  }
                  size="mini"
                  //floated="right"
                  color="blue"
                  onClick={this.setHeightWidthToPortrait}
                >
                  Portrait
                </Button>
                <Button
                  disabled={
                    this.state.orientation === "Landscape" ? true : false
                  }
                  size="mini"
                  //floated="right"
                  color="blue"
                  onClick={this.setHeightWidthToLandscape}
                >
                  Landscape
                </Button>
                {/* <Button
                color="teal"
                size="mini"
                type="button"
                onClick={this.showHideForm}
              >
                Custom
              </Button> */}
              </div>
            )}
            <br />
            {/*  */}
            {/**/}
            <div className="disflex-paginator">
              {/**/}
              {/* {this.state.showForm && this.renderForm()} */}
              {renderPreview()}
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    parameter: state.commons.parameter,
  };
};

export default connect(mapStateToProps, { fetchAppParameter })(AddImage);
